import { getAddresses } from '../../routes/get-addresses';
import { Tabulator, SortModule, EditModule, FormatModule, InteractionModule, ResizeColumnsModule, SelectRowModule, PageModule, FilterModule } from 'tabulator-tables';
//import { tableSearch, tableClear } from './table-helpers';
import { refreshToken } from '../../login/refreshSession';

// Not currently in use
const addressListTable = async () => {
  let addressTable = document.querySelector('.aafp_address-list') as HTMLElement;
  if(!addressTable) return;

  //refreshToken();

  //await getAddresses().then(data => displayAddressTable(data, addressTable));
}

const displayAddressTable = (data: any, element: HTMLElement) => {
  Tabulator.registerModule([SortModule, EditModule, FormatModule, InteractionModule, ResizeColumnsModule, SelectRowModule, PageModule, FilterModule ]);

  function link_button(cell: any, formatterParams: any, onRendered: any) {
    return `<a class='aafp_btn-table-blue' 
            href='/terminal-sites/edit-address/?addressID=${cell.getData().siteId}&addressAction=Edit' 
            data-toggle="tooltip" 
            data-placement="bottom" 
            title="View ${cell.getData().addressStreet1}"><i class="far fa-eye"></i></a>`;
  }

  let addressTableGrid = new Tabulator(element, {
    index: 'ID',
    data: data,
    pagination: true,
    paginationMode: "local",
    paginationSize: 10,
    paginationSizeSelector: [25, 50, 100],
    selectable: false,
    columns: [
      {title:"ID", field:"siteId", visible:false},
      {title: "Address", field: "addressStreet1", sorter: "string", cssClass: "aafp_column-5", resizable: true, vertAlign: 'middle'},
      {title: "City", field: "addressCity", sorter: "string", cssClass: "aafp_column-5", resizable: true, vertAlign: 'middle'},
      {title: "State", field: "addressState", sorter: "string", cssClass: "aafp_column-5", resizable: true, vertAlign: 'middle'},
      {title: "Zip", field: "addressZip", sorter: "string", cssClass: "aafp_column-5", resizable: true, vertAlign: 'middle'},
      {title: "Partner", field: "partnerID", sorter: "string", cssClass: "aafp_column-5", resizable: true, vertAlign: 'middle'},
      // @ts-ignore
      {field: "LinkButton", formatter: link_button, cssClass: "aafp_column-button", hozAlign: 'center', width: 48, headerSort: false, resizable: false,}
    ]
  });

  // let addressSortInput = document.querySelector('#aafp_address-list-sort') as HTMLInputElement;
  // tableSearch('#aafp_address-list-sort', addressTableGrid);
  // tableClear(addressSortInput, addressTableGrid);
}
 
export { addressListTable };